import styles from './Features.module.scss'

interface Card {
  src: string
  alt: string
  title: string
  text: string
}

const cards: Card[] = [
  {
    src: '/images/LP/backend/infra.png',
    alt: 'インフラ',
    title: 'インフラ',
    text: 'システム開発と運用をAWSのクラウドサービスをフル活用しています。月間億単位のアクセスから金融機関の導入にも耐えられるセキュリティ基準での対応が可能です。',
  },
  {
    src: '/images/LP/backend/backend.png',
    alt: 'バックエンド',
    title: 'バックエンド',
    text: 'Atomic システム開発を得意としており、プロジェクトの特性やフェーズに応じて、ウォーターフォールとアジャイル開発を選択して適切なプロジェクトスタイルをご提案します。',
  },
  {
    src: '/images/LP/backend/devprocess.png',
    alt: '開発プロセス',
    title: '開発プロセス',
    text: '継続開発を行うためのデプロイ環境と開発スタイルを取り入れることによって、スピーディーなアプリの改修をサポートします。',
  },
  {
    src: '/images/LP/backend/uidesign.png',
    alt: 'UIデザイン',
    title: 'UIデザイン',
    text: '社内にはエンジニアだけでなく、デザイナーチームも在籍しています。日々エンジニアと議論を重ねています。',
  },
  {
    src: '/images/LP/backend/frontend.png',
    alt: 'フロントエンド',
    title: 'フロントエンド',
    text: 'Atomic Designに基づきコンポーネントを設計することで再利用性の優れたフロントエンドが構築できます。',
  },
]
const Features: React.FC = () => {
  const card = cards.map(({ src, alt, title, text }) => (
    <li key={title} className={styles.card}>
      <div className={styles.img_wrapper}>
        <img key={src} src={src} alt={alt} className={styles.img} />
      </div>
      <div className={styles.text_wrapper}>
        <h3 className={styles.card_title}>{title}</h3>
        <p className={styles.card_text}>{text}</p>
      </div>
    </li>
  ))

  return (
    <section className={styles.section} id="features">
      <h2 className={styles.title}>バックエンド開発を支援します</h2>
      <div className={styles.minitext_wrapper}>
        <p className={styles.minitext}>
          Aitriaでは、UIデザイン、フロントエンドからバックエンド開発まで一貫して対応が可能であり、
          <br />
          デザインとエンジニアリング双方の考え方を理解したデザイナーとエンジニアがチームを組んでいます。
          <br />
          最新のバックエンド技術を駆使して、一緒にシステムを開発しましょう。
        </p>
      </div>
      <div className={styles.card_wrapper}>
        <ul className={styles.ul}>{card}</ul>
      </div>
    </section>
  )
}

export default Features
